import {ModalConstants} from "../constants/modal.constants";

const showModal = ({modalProps, modalType}) => dispatch => {
    dispatch({
        type: ModalConstants.SHOW_MODAL,
        modalProps,
        modalType
    })
};

const hideModal = () => dispatch => {
    dispatch({
        type: ModalConstants.HIDE_MODAL
    })
};

export const modalActions = {
    showModal,
    hideModal
};
